module.exports = __webpack_public_path__ + "static/img/单据采集与智能识别.85c98a59.png";